function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgTwitter = function SvgTwitter(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return React.createElement("svg", _extends({
    "data-name": "twitter",
    viewBox: "0 0 77 64",
    ref: svgRef
  }, props), title ? React.createElement("title", null, title) : null, React.createElement("path", {
    "data-name": "icon",
    d: "M75.79,7.49a31.22,31.22,0,0,1-5.31,1.77,16.15,16.15,0,0,0,4.37-7h0c.21-.73-.63-1.46-1.25-1h0a32.52,32.52,0,0,1-8.12,3.33c-.21,0-.31.1-.52.1a2.47,2.47,0,0,1-1.45-.52A16.58,16.58,0,0,0,52.47,0a18.82,18.82,0,0,0-5.3.83A16,16,0,0,0,36.34,12.38a17.65,17.65,0,0,0-.41,6.14,1,1,0,0,1-.11.42.81.81,0,0,1-.41.21H35.3a44,44,0,0,1-30-16h0a.87.87,0,0,0-1.45.11h0a16.62,16.62,0,0,0-2.29,8.32,16.44,16.44,0,0,0,5,11.86,13.8,13.8,0,0,1-3.64-1.35h0a.83.83,0,0,0-1.25.73h0a16.67,16.67,0,0,0,9.68,15.3h-.31a13.36,13.36,0,0,1-2.81-.31h0a1,1,0,0,0-1,1.14h0A16.65,16.65,0,0,0,20.32,50.26,30.54,30.54,0,0,1,3.15,55.47H1.27A1.32,1.32,0,0,0,0,56.4a1.39,1.39,0,0,0,.62,1.46A45.46,45.46,0,0,0,23.54,64a45.2,45.2,0,0,0,19.57-4.16A43.72,43.72,0,0,0,57.47,49.12a46.59,46.59,0,0,0,8.74-14.67,45.51,45.51,0,0,0,3-16v-.21a2.94,2.94,0,0,1,1-2.18,29.39,29.39,0,0,0,6.56-7.29h0a.83.83,0,0,0-1-1.25Z",
    transform: "translate(0)",
    style: {
      fill: "#ffffff"
    }
  }));
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgTwitter, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Twitter.c1615268.svg";
export { ForwardRef as ReactComponent };